import { CreateFormDto } from "./FormDto";

export interface UpdateFormDto extends CreateFormDto {
  formId: string;
}

export namespace UpdateFormDto {
  export function toJSON(data: UpdateFormDto) {
    return {
      formId: data.formId,
      binusianId: data.binusianId,
      locationId: data.locationId,
      formName: data.name,
      formDescription: data.description,
      imageName: data.imageName,
      imageBase64: data.imageBase64,
      formUrl: data.link,
      isBinusianOnly: !data.isPublic,
    };
  }
}
